//selectors are separate here, in order to break cyclic dependency cycle between actions and reducer
import {selectors as pagedDataSelectors} from "../common/util/pagination/PaginationUtil";
import {ServiceFilter} from "./filter/model";
import {Service} from "./model";

export const moduleName = "services";

const getServiceState = (state) => state[moduleName];

const getServiceById = (state, id: string): Service => {
  const pagedServiceState = getPagedState(state);
  return pagedDataSelectors.getDataById<Service>(pagedServiceState, id);
};

const getServiceProducts = (state, id: string) => {
  const serviceState = getServiceState(state);
  const products = serviceState.serviceProductsById[id];
  return products === undefined ? products : products.slice(0).reverse();
};

const getServicePublishedProducts = (state, id: string) => {
  const serviceState = getServiceState(state);
  const publishedProducts = serviceState.servicePublishedProductsById[id];
  return publishedProducts === undefined ? publishedProducts : publishedProducts.slice(0).reverse();
};

const getFilter = (state): ServiceFilter => {
  const serviceState = getServiceState(state);
  return serviceState.filter;
};

const getPagedState = (state) => {
  const servicesState = getServiceState(state);
  return servicesState.pages;
};

const getSelectedWfsFeatureType = (state, id: string) => {
  const servicesState = getServiceState(state);
  return servicesState?.selectedWfsFeatureType?.[id] ?? null;
};

const getSelectedWmtsProduct = (state, id: string) => {
  const servicesState = getServiceState(state);
  return servicesState?.selectedWmtsProduct?.[id] ?? null;
};


const getAllServiceTypes = (state) => getServiceState(state).allServiceTypes;
const getEnabledServiceTypes = (state) => getServiceState(state).enabledServiceTypes;

export const selectors = {
  getServiceById,
  getServiceProducts,
  getServicePublishedProducts,
  getSelectedWfsFeatureType,
  getSelectedWmtsProduct,
  getPagedState,
  getAllServiceTypes,
  getEnabledServiceTypes,
  getFilter,
};
